import { type Enum } from '@webapp/infrastructure/types/Enum'

export const UserKeys = {
  LIST: 'list',
  DETAIL: 'details',
  PURCHASE_PRICE_LIMIT: 'purchase-price-limit',
  COUNTS: 'counts',
} as const

export type UserKeysEnum = Enum<typeof UserKeys>
